module.exports = __webpack_public_path__ + "img/Portuguese.6c40e933.svg";